module.exports = __webpack_public_path__ + "static/media/backArrowWhite.245c2091.svg";